import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import KollabImageViewer from './KollabImageViewer';
import type { KollabImageViewerProps, KollabImageViewerAPI, KollabImageViewerHandle } from './KollabImageViewer';

window.mountImageViewer = function mountImageViewer(
  containerId: string,
  props: KollabImageViewerProps,
): KollabImageViewerHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabImageViewer: container not found:', containerId);
    return { type: 'image', unmount: () => {}, get api() { return null; } };
  }

  // Add wrapper class for fullscreen and layout
  container.classList.add('kollab-image-viewer-wrapper');

  const mountPoint = document.createElement('div');
  container.appendChild(mountPoint);

  const apiRef = createRef<KollabImageViewerAPI>();
  const root = createRoot(mountPoint);
  root.render(React.createElement(KollabImageViewer, { ...props, containerElement: container, ref: apiRef }));

  return {
    type: 'image',
    unmount: () => {
      root.unmount();
      mountPoint.remove();
      container.classList.remove('kollab-image-viewer-wrapper');
    },
    get api() {
      return apiRef.current;
    },
  };
};

declare global {
  interface Window {
    mountImageViewer: (containerId: string, props: KollabImageViewerProps) => KollabImageViewerHandle;
  }
}
